import { Addition } from "@/pages/heat-report/models/HeatReportModels";
import { ManualAutoButton } from "@/shared/data-entries/ManualAutoButton";
import { dxtToLocalServerTime } from "@dexteel/mesf-core";
import {
  ColDef,
  ColGroupDef,
  ICellRendererParams,
  ValueGetterParams,
} from "ag-grid-enterprise";

export const useTableData = () => {
  const columns: ColGroupDef[] = [
    {
      headerName: "Additions",
      children: [
        {
          field: "Timestamp",
          headerName: "Time",
          flex: 2,
          valueGetter: (params: ValueGetterParams<Addition>) => {
            if (params.data?.Timestamp) {
              return dxtToLocalServerTime(
                (params.data as Addition).Timestamp,
                "HH:mm",
              );
            }
          },
        },
        {
          field: "Source",
          headerName: "Source",
          flex: 2,
        },
        {
          field: "MaterialName",
          headerName: "Material",
          flex: 2,
        },
        {
          field: "Weight",
          headerName: "Weight [lbs]",
          flex: 2,
          valueGetter: (params: ValueGetterParams<Addition>) =>
            params.data?.Weight?.toFixed(0) || "0",
        },
      ],
    },
  ];

  return { columns };
};
